import React, { Component } from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import MaterialTextField from './styled-components/MaterialTextField'
import { Form, FormInputs } from './styled-components/Form'
import ButtonRow from './styled-components/ButtonRow'
import { ButtonPrimary, ButtonSecondaryLink } from './styled-components/Button'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import errorMessages from '../errorMessages'
import { AnovaLogoSmall } from './AnovaLogo'
import { analyticsPage } from '../analytics'

class LogInEmailForm extends Component {
  checkEmailAndRedirectToEnterPassword = (event) => {
    event.preventDefault()
    this.props.checkEmailAndRedirectToEnterPassword()
  }

  componentDidMount () {
    analyticsPage('ALI Log In - Enter Email Form')
  }

  render () {
    return (
      <Card>
        <div>
          <AnovaLogoSmall />
        </div>

        <Form onSubmit={this.checkEmailAndRedirectToEnterPassword} noValidate>
          <HeaderText>
            Continue with email
          </HeaderText>
          <FormInputs>
            <MaterialTextField
              showErrorText={this.props.invalidEmail}
              errorMessage={errorMessages.invalidEmail}
              type="email"
              label="Email"
              autoFocus={true}
              onChange={event => this.props.handleEmailChangeAndClearEmailErrors(event.target.value)}
              value={this.props.email}
              name="emailInput" />
            <ButtonRow>
              <ButtonSecondaryLink
                text="BACK"
                href="/" />
              <ButtonPrimary
                type="submit"
                disabled={!this.props.email}
                data-email-form-next>
                NEXT
              </ButtonPrimary>
            </ButtonRow>
          </FormInputs>

        </Form>

        <TermsOfServiceAndPrivacyPolicy />
      </Card>
    )
  }
}

export default LogInEmailForm
